import React from 'react';

const FilePowerpointIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" {...props}>
    <path d="M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h160v80c0 17.7 14.3 32 32 32h80v288c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3l-90.6-90.5C262.7 6.7 246.5 0 229.5 0H64zm72 208c-13.3 0-24 10.7-24 24v160c0 13.3 10.7 24 24 24s24-10.7 24-24v-32h44c42 0 76-34 76-76s-34-76-76-76h-68zm68 104h-44v-56h44c15.5 0 28 12.5 28 28s-12.5 28-28 28z" />
  </svg>
);

export default FilePowerpointIcon;
